export interface ValidationRule {
  validate: (value: any, options?: any) => string | null
  transform?: (value: any, options?: any) => any
}

export const validationRules = {
  required: {
    validate: (value: string) => (value.trim() !== '' ? null : 'This field is required')
  },

  maxLength: {
    validate: (value: string, { maxLength }: { maxLength: number }) => (value.length <= maxLength ? null : `Must be ${maxLength} characters or less`)
  },

  minLength: {
    validate: (value: string, { minLength }: { minLength: number }) => (value.length >= minLength ? null : `Must be at least ${minLength} characters`)
  },

  alphanumeric: {
    validate: (value: string) => {
      if (value === '') return null
      const alphanumericRegex = /^[a-zA-Z0-9]+$/
      return alphanumericRegex.test(value) ? null : 'Must contain only letters and numbers'
    }
  },

  range: {
    validate: (value: string, { min, max }: { min?: number; max?: number } = {}) => {
      if (value === '') return null

      const num = parseInt(value, 10)
      if (isNaN(num)) return 'Must be a valid number'

      if (min !== undefined && max !== undefined) {
        if (num < min || num > max) return `Value must be between ${min} and ${max}`
      } else if (min !== undefined && num < min) {
        return `Value must be at least ${min}`
      } else if (max !== undefined && num > max) {
        return `Value must be no more than ${max}`
      }

      return null
    },
    transform: (value: string) => {
      const num = parseInt(value, 10)
      return isNaN(num) ? value : num
    }
  }
}

export const processValue = (value: any, rules: ValidationRule[], options: any = {}) => {
  const validation = validateValue(value, rules, options)

  if (!validation.isValid) return { value, isValid: false, error: validation.error }

  let transformedValue = value
  for (const rule of rules) {
    if (rule.transform) {
      transformedValue = rule.transform(transformedValue, options)
    }
  }

  return { value: transformedValue, isValid: true, error: null }
}

export const validateValue = (value: any, rules: ValidationRule[], options: any = {}) => {
  for (const rule of rules) {
    const result = rule.validate(value, options)
    if (result !== null) {
      return { isValid: false, error: result }
    }
  }
  return { isValid: true, error: null }
}
